import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import {
  AppBar,
  Box,
  Grid,
  Toolbar,
  Typography,
  useMediaQuery,
} from '@frontierag/frontier-ui-library';
import { LOGO_HEIGHT, LOGO_HEIGHT_MOBILE } from 'appConstants';
import HeaderMenu from 'components/HeaderMenu';
import logo from 'images/logo.svg';

import { styles } from './styles';
import type { IHeader } from './types';

const Header = ({ showMenu = true, enableLogoClick = true, subtitle }: IHeader) => {
  const { t } = useTranslation('Header');
  const navigate = useNavigate();
  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down('sm'));
  const logoHeight = isMobile ? LOGO_HEIGHT_MOBILE : LOGO_HEIGHT;

  const handleClickLogo = () => {
    navigate('/');
  };

  return (
    <AppBar position="static" elevation={0} data-testid="header-content" sx={styles.appBar}>
      <Toolbar disableGutters>
        <Grid container sx={styles.container}>
          <Grid
            container
            item
            xs
            sm={'auto'}
            justifyContent="flex-start"
            alignItems="center"
            zeroMinWidth
            wrap="nowrap"
            sx={{ cursor: enableLogoClick ? 'pointer' : 'default' }}
            onClick={enableLogoClick ? handleClickLogo : undefined}
          >
            <Box component="img" src={logo} alt="logo" height={logoHeight} />
            <Box sx={styles.line} />
            <Box>
              <Typography
                color="primary"
                variant={subtitle ? 'subtitle1' : 'h3'}
                noWrap
                overflow={{ sm: 'visible' }}
              >
                {t('title')}
              </Typography>
              {subtitle && (
                <Typography
                  color="primary"
                  variant="label2"
                  component="div"
                  noWrap
                  overflow={{ sm: 'visible' }}
                  textAlign="right"
                >
                  {subtitle}
                </Typography>
              )}
            </Box>
          </Grid>
          {showMenu && (
            <Grid item>
              <HeaderMenu />
            </Grid>
          )}
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
